const { VITE_APP_INDEX_DB_VERSION } = import.meta.env

const DB_NAME = "ShipmentsDB"

/* IndexDB version should be increased every time there is a change related indexdb schema or whenever the code is rolled back
    . Decreasing the version number will trigger an error even instead of upgrade. It should be same in IndexDBConfig and worker/dashboard.js also.*/
let DB_VERSION = VITE_APP_INDEX_DB_VERSION

const DB_STORE_TBL_STR = "ShipmentSTR"
const DB_STORE_TBL_INFO = "ShipmentINFO"
const READ_WRITE_MOD = "readwrite"

export const getIndexDBconfig = () => {
    return {
        DB_NAME,
        DB_VERSION,
        DB_STORE_TBL_STR,
        DB_STORE_TBL_INFO,
        READ_WRITE_MOD,
    }
}
